module.exports = __webpack_public_path__ + "img/trains.bf7d13ce.svg";